const breakpoints = {
  mobile: '(max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 1024px)',
  //mobile: '(max-width: 0px)',
};

export default breakpoints;
